<template>
    <form action="" method="POST" @submit.prevent="submit" novalidate>
        <div class="form-toggle-wrapper">
            <form-input-type-toggle
                name="test_account"
                label="Crea un account di test Vitadio per me"
                toggle-position="right"
            ></form-input-type-toggle>
        </div>

        <form-input-type-select
            name="specialization"
            label="Inserisci la tua specializzazione"
            :options="[
                {label: 'Medico di base'},
                {label: 'Diabetologo'},
                {label: 'Consulente per il diabete'},
                {label: 'Psicoterapeuta'},
                {label: 'Nutrizionista'},
                {label: 'Altro'},
            ]"
            :errors="errors.specialization"
            required
            full-border
        ></form-input-type-select>

        <form-input-type-text
            name="title"
            label="Titolo"
            :errors="errors.title"
            full-border
        ></form-input-type-text>

        <form-input-type-text
            name="name"
            label="Nome"
            :errors="errors.name"
            full-border
            required
        ></form-input-type-text>

        <form-input-type-text
            name="surname"
            label="Cognome"
            :errors="errors.surname"
            full-border
            required
        ></form-input-type-text>

        <form-input-type-text
            name="institution"
            label="Nome dello studio / Ditta"
            :errors="errors.institution"
            full-border
        ></form-input-type-text>

        <form-input-type-email
            name="email"
            label="Indirizzo e-mail"
            :errors="errors.email"
            full-border
            required
        ></form-input-type-email>

        <form-input-type-phone-number
            name="phone"
            label="Numero di telefono"
            :errors="errors.phone"
            phoneCountry="it"
            full-border
        ></form-input-type-phone-number>

        <form-input-type-text
            name="address"
            label="Via e numero civico"
            :errors="errors.address"
            full-border
        ></form-input-type-text>

        <div class="col-2">
            <div class="col-item">
                <form-input-type-text
                    name="zip_code"
                    label="Codice postale"
                    :errors="errors.zip_code"
                    full-border
                    required
                ></form-input-type-text>
            </div>

            <div class="col-item">
                <form-input-type-text
                    name="city"
                    label="Città"
                    :errors="errors.city"
                    full-border
                ></form-input-type-text>
            </div>
        </div>

        <form-input-type-text-area
            name="text"
            label="Messaggio"
            :errors="errors.text"
            full-border
        ></form-input-type-text-area>

        <p class="form-mandatory-fields">* I campi contrassegnati da un asterisco (*) sono obbligatori.</p>

        <form-input-type-checkbox
            name="doctor_agreements"
            label="<p>Acconsento che Vitadio e il suo partner commerciale Theras raccolgano i miei dati personali per la creazione di un account di prova per l'applicazione sanitaria digitale “Vitadio“. Inoltre, accetto che queste aziende possano contattarmi per fornire informazioni sul prodotto (ad es. ulteriore sviluppo dell'app, nuove funzioni) sull'app Vitadio utilizzando i dati sopra elencati.</p><p>I tuoi dati saranno trattati in conformità con la nostra informativa sulla privacy.</p>"
            :errors="errors.doctor_agreements"
            required
        ></form-input-type-checkbox>

        <v-button label="Invia" type="submit" size="lg" full-width></v-button>

        <p class="after-form text-default text-centered">Dopo aver inviato la tua richiesta, riceverai una e-mail con tutte le informazioni importanti.</p>
    </form>
</template>

<script>
    export default {
        data() {
            return {
                errors: {},
                ga_client_id: null,
                gcl_id: null
            }
        },
        mounted() {
        },
        methods: {
            submit() {
                let formData = {}
                let that = this

                // serialize form data
                $(this.$el)
                    .serializeArray()
                    .forEach(({ name, value }) => {
                        formData[name] = value
                    })

                let gaCookie = window.getCookie("_ga")
                let gclCookie = window.getCookie("_gcl_aw")

                if(gaCookie !== "" && gaCookie !== "undefined") {
                    this.ga_client_id = gaCookie
                }

                if((gclCookie !== "undefined" && gclCookie !== "") && this.ga_client_id === gaCookie) {
                    this.gcl_id = gclCookie
                }

                formData.ga_client_id = this.ga_client_id
                formData.gcl_id = this.gcl_id

                axios
                    .post('api/doctor-contact-form', formData, {
                        headers: {
                            'Accept-Language': 'it'
                        }
                    })
                    .then((e) => {
                        setTimeout(() => {
                            window.location.replace('operatore-sanitario-success/'+e.data.form_id)
                        }, 250);
                    })
                    .catch((e) => {
                        console.log(e.response)
                        this.errors = e.response.data.errors
                        Vuemit.fire('Button--sending-failed', true)
                        this.scrollToError()
                    })
            },
            async scrollToError() {
                await this.$nextTick()

                var firstError = document.querySelector('.input-error-border')

                $('html, body').animate(
                    {
                        scrollTop: $(firstError).offset().top - 180
                    },
                    800
                )
            }
        }
    }
</script>
